export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-768w.f71d3df4.png";